import { Col, Container, Row } from "react-bootstrap";
import { Jumbotron } from "sections";
import parse from 'html-react-parser';
import { services } from "constants/services";
import { PrimaryButton } from "components/buttons";
import { handleOpenPdf } from "utils";

function ServiceRequestForm() {
  return (
    <div>
      <section className="section jumbotron">
        <Jumbotron badgeText="Services" title={`<span className="jumbotron-subtitle-2">Service Request</span> Form`} />
      </section>
      <section className="wealth">
        <Container>
          <Row>
            <Col md={4}>
              <h2>{services.serviceRequest.about.title}</h2>
            </Col>
            <Col md={8}>
              {parse(services.serviceRequest.about.description)}
            </Col>
          </Row>
          <Row className="my-5 py-5">
            <Col md={4}>
              <h2>{services.serviceRequest.personalInfo.title}</h2>
            </Col>
            <Col md={8}>
              {parse(services.serviceRequest.personalInfo.description)}
            </Col>
          </Row>
          <Row className="my-5 py-5">
            <Col md={4}>
              <h2>{services.serviceRequest.services.title}</h2>
            </Col>
            <Col md={8}>
              {parse(services.serviceRequest.services.description)}
            </Col>
          </Row>
          <Row className="my-5 py-5">
            <Col md={4}>
              <h2>{services.serviceRequest.request.title}</h2>
            </Col>
            <Col md={8}>
              {parse(services.serviceRequest.request.description)}
            </Col>
          </Row>
          <div className="my-4 text-grey-color">
          Thank you for choosing alrajhi bank Malaysia! We look forward to assisting you.
          </div>
          <PrimaryButton text="Service Request Form" onClick={() => handleOpenPdf('https://www.alrajhibank.com.my/assets/pdf/service-request-form/SERVIS REQUEST FORM 2021 1.pdf')} />
        </Container>
      </section>
    </div>
  )
}

export default ServiceRequestForm;